import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Config from '../../utils/config.service';
import Session from '../../utils/session.service';
import RestService from '../../services/core-rest.service';
import AngularHelperService from '../../services/angular-helper.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	standalone: true,
	selector: 'modal-reject-join-request',
	templateUrl: './modal-reject-join-request.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, FormsModule ]
})
export class ModalRejectJoinRequestComponent implements OnInit {
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private restService: RestService = inject(RestService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private dialogRef = inject(MatDialogRef<ModalRejectJoinRequestComponent>);
	private data = inject(MAT_DIALOG_DATA);

	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.vm.getName = this.getName;
		this.vm.submit = this.submit;
		this.vm.close = this.close;
		
		this.initialize();
	}
	
	initialize() {
		this.vm.loaderTimeout = this.angularHelperService.createTimer(() => { this.vm.processing = true; },
			this.config.getOtherConfig()['LOADER_TIMEOUT_INIT']);
		this.vm.uid = 'pe-' + Date.now();
		
		this.vm.joinRequest = this.vm.joinRequest;
		this.vm.user = this.session.getSession().user;
		this.vm.isSignupCompleted = this.vm.user['signupCompleted']
			|| this.vm.user['businessUserType'] === 'SERVICE_OWNER'
			|| this.vm.user['businessUserType'] === 'BUSINESS_CLIENT';
		
		this.vm.rejectReason = '';
		
		this.angularHelperService.cancelTimer(this.vm.loaderTimeout);
		if (this.vm.processing) this.angularHelperService.createTimer(() => { this.vm.processing = false; },
			this.config.getOtherConfig()['LOADER_TIMEOUT_DELAY']);
		
		this.vm.initialized = true;
	}
	
	getName() {
		return this.vm.joinRequest ? this.vm.joinRequest.employee.firstname + ' ' + this.vm.joinRequest.employee.lastname : '';
	}
	
	submit() {
		this.vm.joinRequest.rejectReason = this.vm.rejectReason;
		this.restService.saveBusinessUserJoinRequestReject(this.vm.joinRequest)
			.then((response) => {
				this.dialogRef.close(response);
			})
			.catch((error) => {
				console.log(error);
			});
	}
	
	close() {
		this.dialogRef.close(undefined);
	}
	
}